import React, { Dispatch, SetStateAction, BaseSyntheticEvent, useState, useEffect } from "react";
import Swal from "sweetalert2";
import { ContentCreate, DinamicGridCreate } from "../dinamyc-pages.types";
import { Input } from "../../../../components/Input/Input";
import { ModalImagemCropped } from '../../../../components/Modals/ImagemCropped/ImagemCropped'
import useModals from "../../../../hooks/useModals";
import { resizeImage, validateImage } from "../factory/dinamic-page.aux";
import { i18n } from "../../../../translate/i18n";


type Props = {
    data: ContentCreate
    setData: Dispatch<SetStateAction<any>>
    min?: number
    max?: number
}

export function GridCarousel({ data, setData, min = 1, max = 5 }: Props) {
    const { showImageCropped } = useModals()
    const [originalImageFile, setOriginalImageFile] = useState<File | null>(null)
    const [indexImage, setIndexImage] = useState<number>(0)
    const [imageCrop, setImageCrop] = useState<string | null>('')
    const [isCropped, setCropper] = useState<any>(null)
    const [images, setImages] = useState<File[] | string[]>(data.images || [])



    function getImagetoCrop(file: File, index: number) {
        setOriginalImageFile(file) // Armazenar arquivo original
        const url = URL.createObjectURL(file)
        setImageCrop(url)
        setIndexImage(index)
        showImageCropped()
    }

    const getCropData = async () => {
        if (isCropped) {
            const file = await fetch(isCropped.getCroppedCanvas().toDataURL())
                .then((res) => res.blob())
                .then((blob) => {
                    return new File([blob], 'newAvatar.png', { type: 'image/png' })
                })

            const validImage = await validateImage(file)

            const newImages = images
            newImages[indexImage] = validImage ?? ''
            setImages(newImages)

            setData(newImages)
            setImageCrop('')
            setIndexImage(0)
        }
    }

    const useOriginalImage = async () => {
        if (originalImageFile) {
            const validImage = await validateImage(originalImageFile)


            const newImages = images
            newImages[indexImage] = validImage ?? ''
            setImages(newImages)

            setData(newImages)

            setImageCrop('')
            setIndexImage(0)
        }
    }

    const handleSelectedSize = async (width: number, height: number) => {
        if (originalImageFile) {
            const image = await resizeImage(originalImageFile, width, height)

            const newImages = images
            newImages[indexImage] = image

            setImages(newImages)

            setData(newImages)

            setImageCrop('')
            setIndexImage(0)
        }
    }

    function removeImage(index: number) {
        const newImages = [...images] as (File | string)[]
        newImages[index] = ''
        setImages(newImages as File[] | string[])
        setData(newImages)
    }

    return (
        <div>

            <div className='d-flex flex-wrap gap-4'>{[...Array(4)].map((_, index) => (
                <Input
                    inputAttr={{ type: 'image-agregador' }}
                    label={i18n.t('agregador_dinamic_page.form.share_image_label')}
                    smalltext={i18n.t('agregador_dinamic_page.form.share_image_small_text')}
                    width='200'
                    height='100'
                    value={images[index] || ''}
                    change={(value: BaseSyntheticEvent) => {
                        const file: File | null = value ? value.target.files[0] : null;

                        if (!file) {
                            removeImage(index)
                            return
                        }


                        const sizeInBytes: number = file ? file.size : 0;

                        const sizeInKB = parseFloat((sizeInBytes / 1024).toFixed(2));
                        const sizeInMB = parseFloat((sizeInKB / 1024).toFixed(2));

                        if (sizeInMB > 2) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Erro',
                                text: 'O tamanho do arquivo excede 2MB. Por favor, selecione um arquivo menor.',
                            });
                            return;
                        }
                        getImagetoCrop(file as File, index)
                    }}
                />
            ))}
                <ModalImagemCropped
                    imageCrop={imageCrop}
                    setCropper={setCropper}
                    getCropData={getCropData}
                    onUseOriginalImage={useOriginalImage}
                    onUseSelectedSize={handleSelectedSize}
                    croppedOptions={[{ width: 980, height: 420, value: '980x420' }]}
                />

            </div>
        </div>
    )
}